"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRefundTransactions = exports.getSaleTransaction = exports.processRefundTransaction = exports.processSaleTransaction = exports.getPaymentOptions = exports.getTerminals = exports.getTerminal = exports.getConfigs = void 0;
const shared_1 = require("@getgreenline/shared");
const payment_1 = require("../../models/blazepay/payment");
const refund_1 = require("../../models/blazepay/refund");
const enums_1 = require("../../models/blazepay/enums");
const convertFilterToParams = (filter) => {
    return Object.entries(filter || {}).reduce((acc, [key, value]) => {
        return Object.assign(Object.assign({}, acc), { [`filter[${key}]`]: value });
    }, {});
};
const getConfigs = ({ merchantId }) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield shared_1.axios.get(`${shared_1.BLAZEPAY_API_URL}/api/v1/merchants/${merchantId}/configurations`);
    return res.data;
});
exports.getConfigs = getConfigs;
const getTerminal = ({ merchantId, providerName, deviceId, }) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield shared_1.axios.get(shared_1.BLAZEPAY_API_URL +
        `/api/v1/merchants/${merchantId}/providers/${providerName}/terminals/pos/${deviceId}`);
    return res.data;
});
exports.getTerminal = getTerminal;
const getTerminals = ({ merchantId, filter, }) => __awaiter(void 0, void 0, void 0, function* () {
    const params = filter && convertFilterToParams(Object.assign(Object.assign({}, filter), { terminalId: filter.deviceId, provider: filter.provider }));
    const res = yield shared_1.axios.get(shared_1.BLAZEPAY_API_URL + `/api/v1/merchants/${merchantId}/terminals`, { params });
    return res.data;
});
exports.getTerminals = getTerminals;
const getPaymentOptions = ({ merchantId, filter, }) => __awaiter(void 0, void 0, void 0, function* () {
    const params = filter && convertFilterToParams(filter);
    const res = yield shared_1.axios.get(`${shared_1.BLAZEPAY_API_URL}/api/v1/merchants/${merchantId}/payment-options`, { params });
    return res.data;
});
exports.getPaymentOptions = getPaymentOptions;
/**
 *
 * @description Idempotency-Key should be unique for each request and store it in the database for each transaction
 * @returns
 */
const processSaleTransaction = ({ idempotencyKey, merchantId, providerName, payload: { deviceId, offlinePaymentId, transactionAmount, currentShiftId, customerId }, }) => __awaiter(void 0, void 0, void 0, function* () {
    const headers = Object.assign(Object.assign({}, shared_1.axios.defaults.headers.common), { 'X-Idempotency-Key': idempotencyKey });
    const newPayload = {
        data: {
            type: enums_1.RequestType.PAYMENTS,
            attributes: {
                paymentFlowType: payment_1.PaymentFlowType.TERMINAL,
                orderId: offlinePaymentId,
                requestedAmount: transactionAmount,
                terminalId: deviceId,
                employeeId: currentShiftId,
                customerId,
            },
        },
    };
    const res = yield shared_1.axios.post(shared_1.BLAZEPAY_API_URL + `/api/v1/merchants/${merchantId}/providers/${providerName}/payments`, newPayload, { headers });
    return res.data;
});
exports.processSaleTransaction = processSaleTransaction;
/**
 *
 * @description Idempotency-Key should be unique for each request and store it in the database for each transaction
 * @returns
 */
const processRefundTransaction = ({ idempotencyKey, merchantId, providerName, payload: { deviceId, transactionAmount, currentShiftId, reason, paymentId }, }) => __awaiter(void 0, void 0, void 0, function* () {
    const headers = Object.assign(Object.assign({}, shared_1.axios.defaults.headers.common), { 'X-Idempotency-Key': idempotencyKey });
    const newPayload = {
        data: {
            type: enums_1.RequestType.REFUNDS,
            attributes: {
                requestedAmount: transactionAmount,
                refundType: refund_1.RefundType.REFUND,
                reason,
                paymentId,
                terminalId: deviceId,
                employeeId: currentShiftId,
            },
        },
    };
    const res = yield shared_1.axios.post(shared_1.BLAZEPAY_API_URL + `/api/v1/merchants/${merchantId}/providers/${providerName}/refunds`, newPayload, { headers });
    return res.data;
});
exports.processRefundTransaction = processRefundTransaction;
const getSaleTransaction = ({ merchantId, providerName, transactionId, }) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield shared_1.axios.get(shared_1.BLAZEPAY_API_URL +
        `/api/v1/merchants/${merchantId}/providers/${providerName}/payments/${transactionId}`);
    return res.data;
});
exports.getSaleTransaction = getSaleTransaction;
const getRefundTransactions = ({ merchantId, providerName, filter, }) => __awaiter(void 0, void 0, void 0, function* () {
    const params = filter && convertFilterToParams(filter);
    const res = yield shared_1.axios.get(shared_1.BLAZEPAY_API_URL + `/api/v1/merchants/${merchantId}/providers/${providerName}/refunds`, {
        params,
    });
    return res.data;
});
exports.getRefundTransactions = getRefundTransactions;
//# sourceMappingURL=BlazepayAPI.js.map